import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { IconCalender } from "@mzc-cloudplex/icons";
import { TextField } from "@mzc-pdc/ui";
import dayjs from "dayjs";
import { StyledDateTimePicker } from "@features/datepicker/dateTimepicker.styled";

export const BasicDateTimePicker = ({
    label,
    width,
    defaultValue,
    value,
    minDate,
    maxDate,
    sx,
    onError,
    helperText,
    onChangeValue,
}) => {
    const handleClear = () => {
        onChangeValue(null);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StyledDateTimePicker
                sx={sx}
                label={label && label}
                defaultValue={defaultValue ? dayjs(defaultValue) : undefined}
                value={value ? dayjs(value) : null}
                minDate={minDate ? dayjs(minDate) : undefined}
                maxDate={maxDate ? dayjs(maxDate) : undefined}
                width={width}
                dateFormat={"YYYY-MM-DD hh:mm A"}
                format={"YYYY-MM-DD hh:mm A"}
                components={{
                    OpenPickerIcon: IconCalender,
                }}
                onChange={(newValue) => {
                    if (onChangeValue) onChangeValue(newValue);
                }}
                onError={(error) => {
                    if (onError) onError(error);
                }}
                slotProps={{
                    textField: {
                        InputLabelProps: {
                            shrink: true,
                        },
                        helperText: helperText,
                    },
                    popper: {
                        disablePortal: true,
                    },
                }}
                DialogProps={{
                    PaperProps: {
                        sx: {
                            width: "500px", // 원하는 너비로 설정
                        },
                    },
                }}
                renderInput={(params) => {
                    return (
                        <TextField
                            {...params}
                            inputProps={{
                                ...params.inputProps,
                                placeholder: "YYYY-MM-DD hh:mm A",
                            }}
                        />
                    );
                }}
            />
        </LocalizationProvider>
    );
};
